import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { View } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { Modal, ModalControls } from '../../../../components/Modal';
import { VehicleAvatar } from '../../../../components/VehicleAvatar';
import { selectWorks } from '../../../Api/selectors';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import { performAction } from '../../actions';
import {
  REQUEST_KANBAN_BOARD_PERFORM_ACTION,
  TASK_STATUS_ACTIVE,
  TASK_STATUS_INACTIVE,
  TASK_STATUS_PLAN,
} from '../../constants';
import { Cell } from '../Cell';
import { PerformActionButton } from '../PerformActionButton';
import { BaseCellComp } from '../BaseCellComp';
import { CellButton, CellButtons } from '../CellButton';
import { Well } from '../../../../components/Well';
import { VBox } from '../../../../components/Box';
import { Checkbox } from '../../../../components/Checkbox';
import { selectVehicle } from '../../../Vehicles/selectors';
import { VehiclePropertyLoadable } from '../../../Vehicles/components/VehiclePropertyLoadable';
import { WithVehicleProperty } from '../../../Vehicles/components/WithVehicleProperty';
import { deleteVehicleProperty, setVehicleProperty } from '../../../Vehicles/actions';
import { VehiclePropertyCheckbox } from '../../../Vehicles/components/VehiclePropertyCheckbox';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import styles from './HOOI.module.css';

const Container = styled.div``;

const DEFAULTS = {};

const FIELDS2 = {
  HOOI_task_extreme_cleaning: '0',
  HOOI_task_desticker: '0',
  HOOI_task_polish_exterior: '0',
};

const binaryTypes = {
  task_attach_replate: '0',
};

const STATE = {
  approve: false,
  task_attach_replate: '0',
  ...DEFAULTS,
  ...FIELDS2,
  changed: {},
};

/* eslint-disable react/prefer-stateless-function */
class HOOI_check_autoComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  toggleField = name => {
    if (this.state[name] === '1') {
      this.setState({ [name]: '0' });
    } else {
      this.setState({ [name]: '1' });
    }
  };

  setField = (name, value) => {
    this.setState(prevState => ({
      ...prevState,
      changed: { ...prevState.changed, [name]: value },
    }));
  };

  generatePayload() {
    return this.state?.changed ?? {};
  }

  renderPlannable(name) {
    //use the fetched vehicle in the modal
    return (
      <VehiclePropertyCheckbox
        vehicleId={this.props.cell.vehicle.id}
        propertyName={name}
        key={name}
        changedValue={this.state.changed[name]}
        setField={this.setField.bind(this)}
      />
    );
    // const vehicle = this.props.vehicle;
    // return (
    //   <WithVehicleProperty vehicleId={this.props.cell.vehicle.id} propertyName={name} key={name}>
    //     <VehiclePropertyLoadable name={name}>
    //       <Checkbox
    //         key={name}
    //         checked={vehicle?.[name]}
    //         onChange={() => {
    //           console.dir(vehicle);
    //           debugger;
    //           if (vehicle?.[name]) this.props.deleteProperty(name);
    //           else this.props.setProperty(name, '1');
    //         }}
    //       >
    //         {this.lbl(`vehicle.property.${name}`)}
    //       </Checkbox>
    //     </VehiclePropertyLoadable>
    //   </WithVehicleProperty>
    // );
  }

  renderApprove() {
    const vehicle = this.props.cell.vehicle;
    if (!this.state.approve) return null;

    let shownFields = { ...FIELDS2 };

    for (let name in shownFields) {
      if (!!vehicle[name]) {
        shownFields[name] = vehicle[name];
      }
    }

    this.setState({ ...shownFields });

    return (
      <ModalComponent onClose={this.reset.bind(this)} title={this.props.action.label}>
        <VehicleHeader vehicle={vehicle} />
        {vehicle?.fix_damages_details && (
          <div style={{ maxWidth: '400px' }}>
            <strong>{this.lbl(`kanban.transport_card.fix_damages_details`)}: </strong>
            <span>{vehicle?.fix_damages_details}</span>
          </div>
        )}

        <VBox>
          {/* {_.map(DEFAULTS, (value, name) => [name, value])
            .filter(m => m)
            .map(pair => (
              <>
                <Checkbox
                  key={pair[0]}
                  checked={this.state[pair[0]] || !!this.state[pair[0]]}
                  onChange={this.setStateFn({ [pair[0]]: !this.state[pair[0]] })}
                >
                  {this.lbl(`vehicle.property.${pair[0]}`)}
                </Checkbox>
              </>
            ))} */}

          <div className="mt-2 mb-2">{_.map(shownFields, (value, name) => this.renderPlannable(name))}</div>
        </VBox>
        <div className="d-flex gap-2 mt-2">
          <PerformActionButton
            className={styles.confirmButton}
            payload={this.generatePayload()}
            action={this.props.action}
            target={vehicle}
            onChange={this.reset.bind(this)}
          />
          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }

  render() {
    //use the vehicle from the 'action' in the small card
    const vehicle = this.props.cell.vehicle;

    return (
      <Cell className={styles.cell}>
        <Container>
          <VehicleHeader vehicle={vehicle} />
          <CellButtons>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <div className={styles.cellButtonContainer}>
                <CellButton onClick={this.setStateFn({ approve: !this.state.approve })}>
                  <View />
                </CellButton>
              </div>
            )}
          </CellButtons>
        </Container>
        {this.renderApprove()}
      </Cell>
    );
  }
}

HOOI_check_autoComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([`${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle.id}`]),
    vehicle: selectVehicle(ownProps.cell.vehicle.id),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,

    setProperty(name, value) {
      dispatch(setVehicleProperty(ownProps.cell.vehicle.id, name, value));
    },
    deleteProperty(name) {
      dispatch(deleteVehicleProperty(ownProps.cell.vehicle.id, name));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const HOOI_check_auto = compose(withConnect, withRouter)(HOOI_check_autoComp);
